import { VOICE_WEBRTC_REMOTE_MEDIA_ELEMENT_ID } from '../config/voiceWebRtcConfig';
import { isAgentCallDead, isAgentSessionAlreadyAnswered } from './voiceJsSipSessionStatus';

export const AGENT_ANSWER_ABORTED = 'agent_answer_aborted';

function createVoiceAgentState() {
  return {
    sipUserAgent: null,
    currentRtcSession: null,
    agentClientReady: false,
    agentPeerConnectionConfig: undefined,
    agentIcePrewarmPromise: null,
    agentIcePrewarmPeerConnection: null,
    agentIcePrewarmWaitResolve: null,
    agentRemoteMediaElementId: VOICE_WEBRTC_REMOTE_MEDIA_ELEMENT_ID,
    pendingAutoAnswerCallControlId: null,
    agentAnswerBridgeCallControlId: null,
    connectAgentWebRtcInFlight: null,
    disconnectAgentWebRtcInFlight: null,
    /** When true, sdk.disconnected must not schedule auto-reconnect (intentional stop / pagehide). */
    intentionalTeardown: false,
    reconnectAttempt: 0,
    reconnectTimerId: null,
    pageLifecycleBound: false,
    sdkListeners: new Set(),
    pendingIncomingResolvers: new Set(),
    agentSessionAnswerInFlight: new WeakMap(),
    agentSessionAnswerInitiated: new WeakSet()
  };
}

let state = createVoiceAgentState();

export function getVoiceAgentState() {
  return state;
}

export function resetVoiceAgentState() {
  state = createVoiceAgentState();
}

export function getCurrentAgentCall() {
  return state.currentRtcSession;
}

export function isAgentClientConnected() {
  return Boolean(state.sipUserAgent?.isRegistered());
}

export function isCurrentAgentSessionDead() {
  return isAgentCallDead(state.currentRtcSession);
}

export function emitSdkEvent(event) {
  state.sdkListeners.forEach((listener) => {
    try {
      listener(event);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Voice agent WebRTC subscriber error:', error);
    }
  });
}

export function subscribeAgentSdkEvents(listener) {
  state.sdkListeners.add(listener);
  return () => state.sdkListeners.delete(listener);
}

export function isAgentSessionAnswerInitiated(session) {
  return Boolean(session && state.agentSessionAnswerInitiated.has(session));
}

export function canTreatAgentIceAsPostAnswer(session) {
  return isAgentSessionAlreadyAnswered(session) || isAgentSessionAnswerInitiated(session);
}
